<mat-progress-bar mode="indeterminate" *ngIf="isLoading | async"></mat-progress-bar>
<router-outlet></router-outlet>